import React from 'react';
import styled from 'styled-components';
import { Icon } from '../../Atoms/Icon';
import { NAV_BAR_ITEM_BASE_STYLE } from './shared.styles';
const StyledNavBar = styled.div `
    flex-basis: 19.25rem;
    width: 19.25rem;
    height: 100%;

    display: flex;
    flex-direction: column;

    color: white;
    background: #33373d;

`;
// Pins nested elements to the bottom of the Nav Bar
const BottomNavItems = styled.div `
    margin-top: auto;
    flex-direction: column;
`;
/**
 * Styled Container representing the left hand side navigation bar
 */
const NavBar = ({ children, className }) => {
    return (React.createElement(StyledNavBar, { className: className }, children));
};
// Nav Bar Item, setting pinTo = 'bottom' pushes the item to the bottom, you can stack these
const StyledNavBarItem = styled.div `
    && {
        ${NAV_BAR_ITEM_BASE_STYLE}
        margin-top: ${({ pinTo }) => (pinTo === 'bottom' ? 'auto' : 'initial')};
    }
`;
const NavBarItem = ({ navIcon, title, pinTo, className = '', isDisabled = false, onClick = () => { }, }) => {
    return (React.createElement(StyledNavBarItem, { className: className, pinTo: pinTo, isDisabled: isDisabled, onClick: onClick },
        React.createElement(Icon, { icon: navIcon }),
        React.createElement("span", null, title)));
};
export { NavBar, NavBarItem, BottomNavItems };
